import React, { useEffect, useState } from 'react'
import Reflux from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, CustomInput, Input, UncontrolledTooltip as Tooltip } from 'reactstrap'
import 'moment/locale/da'
import { toast } from 'react-toastify'
import { Warning } from '@material-ui/icons'

export const FooterSectionList = () => {
  const [footerSections, setFooterSections] = useState([])
  const [links, setLinks] = useState([])
  const [loading, setLoading] = useState(false)

  const getFooterSections = async () => {
    setLoading(true)

    const responseJson = await GET('footerSections/pool')
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Fetching FooterSections Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setFooterSections(responseJson)
      }
    }

    setLoading(false)
  }

  const deleteFooterSection = async FooterSectionID => {
    const responseJson = await POST('footerSections/removeFooterSection', { FooterSectionID: FooterSectionID })
    if (responseJson.error) {
      toast.error('Delete FooterSection Failed', {
        autoClose: 7500
      })
    } else {
      setFooterSections(footerSections.filter(fs => fs.FooterSectionID !== FooterSectionID))
      toast.success('FooterSection Deleted', {
        autoClose: 7500
      })
    }
  }

  const canEdit = section => {
    const sessionBrandId = Reflux.GlobalState.LoginStore.settings ? Reflux.GlobalState.LoginStore.settings.BrandID : null
    return sessionBrandId === 9 || sessionBrandId === section.BrandID
  }

  const getLinks = async () => {
    const responseJson = await GET('footerSections/getFooterSectionLinksForBrand')
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Fetch links Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setLinks(responseJson)
      }
    }
  }

  const addLink = async (FooterSectionID, placement) => {
    const responseJson = await POST('footerSections/addBrandLink', { FooterSectionID: FooterSectionID, placement: placement })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Fetch links Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setLinks([...links, { FooterSectionID: FooterSectionID, poolOrder: 0, placement: placement }])
        toast.success(`Aktiverede sektion`, {
          autoClose: 7500
        })
      }
    }
  }

  const replaceLink = async (FooterSectionID, poolOrder, placement) => {
    const responseJson = await POST('footerSections/replaceBrandLink', {
      FooterSectionID: FooterSectionID,
      placement: placement,
      poolOrder: poolOrder
    })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Replacing link Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        const newLinks = links.map(l => {
          if (l.FooterSectionID === FooterSectionID && l.placement === placement) {
            return { ...l, poolOrder: poolOrder }
          } else {
            return l
          }
        })
        setLinks(newLinks)
        toast.success(`Opdaterede sektion`, {
          autoClose: 7500
        })
      }
    }
  }

  const removeLink = async (FooterSectionID, placement) => {
    const responseJson = await POST('footerSections/removeBrandLink', { FooterSectionID: FooterSectionID, placement: placement })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Removing link Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        const newLinks = links.filter(l => l.FooterSectionID !== FooterSectionID || l.placement !== placement)
        setLinks(newLinks)
        toast.success(`Deaktiverede sektion`, {
          autoClose: 7500
        })
      }
    }
  }

  useEffect(() => {
    getFooterSections()
    getLinks()
  }, [])

  if (loading) {
    return <FontAwesomeIcon icon='spinner' spin />
  }

  const amountSelectedFront = links.filter(l => l.placement === 'FRONT').length
  const amountSelectedFaq = links.filter(l => l.placement === 'FAQ').length

  return (
    <CollapsibleCard startOpen header={<strong>Footersektioner</strong>}>
      <DynamicTable
        responsive
        size='sm'
        options={{
          startSort: {
            dir: 'DESC',
            column: 'FooterSectionID'
          },
          fieldFunctions: {
            activeFront: e => {
              return (
                <CustomInput
                  type='checkbox'
                  id={`activeFront${e.FooterSectionID}`}
                  checked={links.some(l => l.FooterSectionID === e.FooterSectionID && l.placement === 'FRONT')}
                  disabled={amountSelectedFront >= 4 && !links.some(l => l.FooterSectionID === e.FooterSectionID && l.placement === 'FRONT')}
                  onChange={v => {
                    if (v.target.checked) {
                      addLink(e.FooterSectionID, 'FRONT')
                    } else {
                      removeLink(e.FooterSectionID, 'FRONT')
                    }
                  }}
                />
              )
            },
            activeFaq: e => {
              return (
                <CustomInput
                  type='checkbox'
                  id={`activeFaq${e.FooterSectionID}`}
                  checked={links.some(l => l.FooterSectionID === e.FooterSectionID && l.placement === 'FAQ')}
                  disabled={amountSelectedFaq >= 4 && !links.some(l => l.FooterSectionID === e.FooterSectionID && l.placement === 'FAQ')}
                  onChange={v => {
                    if (v.target.checked) {
                      addLink(e.FooterSectionID, 'FAQ')
                    } else {
                      removeLink(e.FooterSectionID, 'FAQ')
                    }
                  }}
                />
              )
            },
            poolOrderFront: e => {
              return (
                <Input
                  type='number'
                  defaultValue={links.find(l => l.FooterSectionID === e.FooterSectionID && l.placement === 'FRONT')?.poolOrder}
                  onBlur={v => {
                    replaceLink(e.FooterSectionID, Number(v.target.value), 'FRONT')
                  }}
                  disabled={!links.some(l => l.FooterSectionID === e.FooterSectionID && l.placement === 'FRONT')}
                  style={{ width: 100 }}
                />
              )
            },
            poolOrderFaq: e => {
              return (
                <Input
                  type='number'
                  defaultValue={links.find(l => l.FooterSectionID === e.FooterSectionID && l.placement === 'FAQ')?.poolOrder}
                  onBlur={v => {
                    replaceLink(e.FooterSectionID, Number(v.target.value), 'FAQ')
                  }}
                  disabled={!links.some(l => l.FooterSectionID === e.FooterSectionID && l.placement === 'FAQ')}
                  style={{ width: 100 }}
                />
              )
            }
          },
          addField: e => {
            return (
              <td>
                <ButtonGroup>
                  <Tooltip target={'edit' + e.FooterSectionID}>Rediger</Tooltip>
                  <Button tag={Link} to={'/footer-sections/' + e.FooterSectionID} id={'edit' + e.FooterSectionID} disabled={!canEdit(e)}>
                    <FontAwesomeIcon icon='edit' />
                  </Button>
                  <Tooltip target={'delete' + e.FooterSectionID}>Slet</Tooltip>
                  <Button
                    id={'delete' + e.FooterSectionID}
                    color='danger'
                    onClick={() => {
                      if (confirm('Vil du slette denne sektion?')) {
                        deleteFooterSection(e.FooterSectionID)
                      }
                    }}
                    disabled={!canEdit(e)}
                  >
                    <FontAwesomeIcon icon='trash' />
                  </Button>
                </ButtonGroup>
              </td>
            )
          }
        }}
        headers={{
          FooterSectionID: 'ID',
          BrandID: 'Brand ID',
          title: 'Titel',
          activeFront: 'Aktiv (forside)',
          poolOrderFront: 'Rækkefølge (forside)',
          activeFaq: 'Aktiv (FAQ)',
          poolOrderFaq: 'Rækkefølge (FAQ)'
        }}
        data={footerSections}
      />

      {(amountSelectedFront < 4 || amountSelectedFaq < 4) && (
        <div style={{ display: 'flex', gap: 10 }}>
          <Warning style={{ color: '#f3e308ff' }} />
          <b>Aktivér 4 sektioner til både forside og FAQ</b>
        </div>
      )}
    </CollapsibleCard>
  )
}
